export default __webpack_public_path__ + "0a662dd55cc6187eefa6933017cfab60.glb";